import { AxiosRequestConfig } from 'axios';
import request from 'src/services/request';
import { IJob } from 'src/models/jobs';

export function getJobs(qs) {
  return '/board/jobs' + qs;
}

export function getJob(id: number, config?: AxiosRequestConfig) {
  return request.get<void, IJob>(`/jobs/${id}`, config);
}

export function getCompanyJob(companySlug: string | number, id: number, config?: AxiosRequestConfig) {
  return request.get<void, IJob>(`/companies/${companySlug}/jobs/${id}`, config);
}

export const reorderStep = jobId => `/companies/companyId/jobs/${jobId}/steps/reorder`;

export function createJob(companySlug: string | number, payload: IJob) {
  return request.post<void, IJob>(`/companies/${companySlug}/jobs`, payload);
}

export function updateJob({ companySlug, ...job }, config?: AxiosRequestConfig) {
  return request.put(`/companies/${companySlug}/jobs/${job.id}`, job, config);
}

export function deleteJob(id) {
  return request.delete(`/jobs/${id}`);
}

type IPostCvResponse = {
  filename: string;
  resume_url: string;
};

export function uploadCV({ jobId, payload }) {
  return request.post<void, IPostCvResponse>(`/jobs/${jobId}/applications/resume`, payload);
}

export function uploadPhoto({ jobId, payload }) {
  return request.post<void, IPostCvResponse>(`/jobs/${jobId}/applications/photo`, payload);
}

export function applyForJob({ jobId, payload }, config?: AxiosRequestConfig) {
  return request.post(`/jobs/${jobId}/applications`, payload, config);
}

export function simpleApplyForJob({ jobId, from_careers_page }, config?: AxiosRequestConfig) {
  return request.post(`/jobs/${jobId}/applications/simple_apply`, { from_careers_page }, config);
}

export function checkForJobApplication({ jobId }, config?: AxiosRequestConfig) {
  return request.get(`/jobs/${jobId}/check_apply`, config);
}

export function getJobAccessPolicies({ companySlug, jobId }, config?: AxiosRequestConfig) {
  return request.get<void, any>(`/companies/${companySlug}/jobs/${jobId}/policies`, config);
}

export function getJobApplicationSettings({ companySlug, jobId }, config?: AxiosRequestConfig) {
  return request.get<void, any>(`/companies/${companySlug}/jobs/${jobId}/application_forms`, config);
}

export function updateJobApplicationSettings({ companySlug, jobId, ...payload }, config?: AxiosRequestConfig) {
  return request.put<void, any>(`/companies/${companySlug}/jobs/${jobId}/application_forms`, payload, config);
}

export function getJobAdvertising({ companySlug, jobId }, config?: AxiosRequestConfig) {
  return request.get<void, any>(`/companies/${companySlug}/jobs/${jobId}/advertising`, config);
}

export function updateJobAdvertising({ companySlug, jobId, ...payload }, config?: AxiosRequestConfig) {
  return request.put(`/companies/${companySlug}/jobs/${jobId}/advertising`, payload, config);
}

export function getJobFeeds({ companySlug, jobId }, config?: AxiosRequestConfig) {
  return request.get<void, any>(`/companies/${companySlug}/jobs/${jobId}/feeds`, config);
}

export function updateJobFeeds({ companySlug, jobId, ...payload }, config?: AxiosRequestConfig) {
  return request.put<void, any>(`/companies/${companySlug}/jobs/${jobId}/feeds`, payload, config);
}

export function deleteJobFeeds({ companySlug, jobId }, config?: AxiosRequestConfig) {
  return request.delete<void, any>(`/companies/${companySlug}/jobs/${jobId}/feeds`, config);
}

export function getJobMembers({ companySlug, jobId }, config?: AxiosRequestConfig) {
  return request.get<void, any>(`/companies/${companySlug}/jobs/${jobId}/members`, config);
}

export function updateJobMembers({ companySlug, jobId, ...payload }, config?: AxiosRequestConfig) {
  return request.put<void, any>(`/companies/${companySlug}/jobs/${jobId}/members`, payload, config);
}

export function getJSS({ companySlug, jobId }, config?: AxiosRequestConfig) {
  return request.get(`/companies/${companySlug}/jobs/${jobId}/suggestions_setting`, config);
}

export function updateJSS({ companySlug, jobId, ...payload }, config?: AxiosRequestConfig) {
  return request.patch(`/companies/${companySlug}/jobs/${jobId}/suggestions_setting`, payload, config);
}
export function uploadCustomFileAnswer({ jobId, file }) {
  return request.post(`/jobs/${jobId}/applications/answer_file`, file);
}
